module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_gov.cc6b1e840dadcb78eb8612f73328a505.png";